// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"3afc97c2","732":"96e5ed2c"}[chunkId] + ".chunk.js");